module.exports = __webpack_public_path__ + "img/zhjxhsp-bg.994bbf66.png";